import { render, staticRenderFns } from "./modalFruit.vue?vue&type=template&id=4f45cf0d&scoped=true&"
import script from "./modalFruit.vue?vue&type=script&lang=js&"
export * from "./modalFruit.vue?vue&type=script&lang=js&"
import style0 from "./modalFruit.vue?vue&type=style&index=0&id=4f45cf0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45cf0d",
  null
  
)

export default component.exports